var pug = require("!../../../../../aan/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (items, key, overlayText, prefix) {var classes = {
    graphic: 'thumbnail',
    table: 'thumbnail',
    media: 'thumbnail'
};
var icons = {
    table: 'icon-tables',
    media: 'icon-digital-object'
};
var renderOverlay = {
    graphic: true,
    table: false,
    media: false
};

pug_mixins["renderThumbnails"] = pug_interp = function(key, root, overlay){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cspan" + (pug.attr("class", pug.classes([classes[key]], [true]), false, true)) + "\u003E";
switch (key){
case 'graphic':
pug_html = pug_html + (null == (pug_interp = root.modifiedContent) ? "" : pug_interp);
  break;
case 'table':
pug_html = pug_html + "\u003Ci" + (pug.attr("class", pug.classes([icons[key]], [true]), false, true)+" aria-hidden=\"true\"") + "\u003E\u003C\u002Fi\u003E";
  break;
case 'media':
pug_html = pug_html + "\u003Ci" + (pug.attr("class", pug.classes([icons[key]], [true]), false, true)+" aria-hidden=\"true\"") + "\u003E\u003C\u002Fi\u003E";
  break;
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
if ((overlay && renderOverlay[key])) {
pug_html = pug_html + "\u003Cspan class=\"overlay\"\u003E\u003Cspan\u003E" + (null == (pug_interp = overlay) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
}
};
// iterate items
;(function(){
  var $$obj = items;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var item = $$obj[index];
const root = item.multiFigure ? item.multiFigure[0] : item;
const str = '<div class="heading">' + item.title + '</div>';
const str2 = '<span class="heading">'+item.title+'</span>.';
const str3 = '<span class="heading">'+item.title+'</span>';
let renderTitle = true;
let renderCaption = true;
let renderNotes = false;
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([prefix+'__item'], [true]), false, true)) + "\u003E";
const ariaLabel = item.title ? 'View ' + item.title : 'View figure ' + (1 + index);
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes([prefix+'__item__thumbnail'], [true]), false, true)+pug.attr("data-target", prefix+'-'+item.id, true, true)+pug.attr("aria-label", ariaLabel, true, true)+" data-open=\"viewer\"") + "\u003E";
pug_mixins["renderThumbnails"](key, root, overlayText);
pug_html = pug_html + "\u003C\u002Fbutton\u003E\u003Cdiv" + (pug.attr("class", pug.classes([prefix+'__item__content'], [true]), false, true)) + "\u003E";
if ((item.title && renderTitle)) {
pug_html = pug_html + "\u003Cdiv class=\"title\"\u003E" + (null == (pug_interp = item.title) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([prefix+'__item__content__inner'], [true]), false, true)) + "\u003E";
if ((item.caption && renderCaption)) {
if ((item.caption.split(str)[1])) {
pug_html = pug_html + "\u003Cdiv class=\"caption\"\u003E" + (null == (pug_interp = item.caption.split(str)[0]) ? "" : pug_interp) + "\n" + (null == (pug_interp = item.caption.split(str)[1]) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
else
if ((item.caption.split(str2)[1])) {
pug_html = pug_html + "\u003Cdiv class=\"caption\"\u003E" + (null == (pug_interp = item.caption.split(str2)[0]) ? "" : pug_interp) + "\n" + (null == (pug_interp = item.caption.split(str2)[1]) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
else
if ((item.caption.split(str3)[1])) {
pug_html = pug_html + "\u003Cdiv class=\"caption\"\u003E" + (null == (pug_interp = item.caption.split(str3)[0]) ? "" : pug_interp) + "\n" + (null == (pug_interp = item.caption.split(str3)[1]) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"caption\"\u003E" + (null == (pug_interp = item.caption) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
}
if ((item.notes && renderNotes)) {
pug_html = pug_html + (null == (pug_interp = item.notes) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var item = $$obj[index];
const root = item.multiFigure ? item.multiFigure[0] : item;
const str = '<div class="heading">' + item.title + '</div>';
const str2 = '<span class="heading">'+item.title+'</span>.';
const str3 = '<span class="heading">'+item.title+'</span>';
let renderTitle = true;
let renderCaption = true;
let renderNotes = false;
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([prefix+'__item'], [true]), false, true)) + "\u003E";
const ariaLabel = item.title ? 'View ' + item.title : 'View figure ' + (1 + index);
pug_html = pug_html + "\u003Cbutton" + (pug.attr("class", pug.classes([prefix+'__item__thumbnail'], [true]), false, true)+pug.attr("data-target", prefix+'-'+item.id, true, true)+pug.attr("aria-label", ariaLabel, true, true)+" data-open=\"viewer\"") + "\u003E";
pug_mixins["renderThumbnails"](key, root, overlayText);
pug_html = pug_html + "\u003C\u002Fbutton\u003E\u003Cdiv" + (pug.attr("class", pug.classes([prefix+'__item__content'], [true]), false, true)) + "\u003E";
if ((item.title && renderTitle)) {
pug_html = pug_html + "\u003Cdiv class=\"title\"\u003E" + (null == (pug_interp = item.title) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes([prefix+'__item__content__inner'], [true]), false, true)) + "\u003E";
if ((item.caption && renderCaption)) {
if ((item.caption.split(str)[1])) {
pug_html = pug_html + "\u003Cdiv class=\"caption\"\u003E" + (null == (pug_interp = item.caption.split(str)[0]) ? "" : pug_interp) + "\n" + (null == (pug_interp = item.caption.split(str)[1]) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
else
if ((item.caption.split(str2)[1])) {
pug_html = pug_html + "\u003Cdiv class=\"caption\"\u003E" + (null == (pug_interp = item.caption.split(str2)[0]) ? "" : pug_interp) + "\n" + (null == (pug_interp = item.caption.split(str2)[1]) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
else
if ((item.caption.split(str3)[1])) {
pug_html = pug_html + "\u003Cdiv class=\"caption\"\u003E" + (null == (pug_interp = item.caption.split(str3)[0]) ? "" : pug_interp) + "\n" + (null == (pug_interp = item.caption.split(str3)[1]) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"caption\"\u003E" + (null == (pug_interp = item.caption) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
}
if ((item.notes && renderNotes)) {
pug_html = pug_html + (null == (pug_interp = item.notes) ? "" : pug_interp);
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);
}.call(this,"items" in locals_for_with?locals_for_with.items:typeof items!=="undefined"?items:undefined,"key" in locals_for_with?locals_for_with.key:typeof key!=="undefined"?key:undefined,"overlayText" in locals_for_with?locals_for_with.overlayText:typeof overlayText!=="undefined"?overlayText:undefined,"prefix" in locals_for_with?locals_for_with.prefix:typeof prefix!=="undefined"?prefix:undefined));;return pug_html;};
module.exports = template;